import styles from "./styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import {Button} from "@shopify/polaris";
import {signUtmParams} from "../../../../../helpers/signUtmParams";
import {useRouter} from "next/router";
import PropTypes from "prop-types";
import {MONTHLY} from "../index";
import cn from "classnames";
import {COMMON_NAMESPACE} from "../../../../../utils/i18nNameSpaces";

const Cards = ({namespace, payment, plans, link}) => {
  const {t} = useTranslation(namespace);
  const router = useRouter();

  const cartsMonthly = [
    {
      has: !!plans?.monthly?.free,
      header: t("pricing.free.header"),
      pricing: {
        value: plans?.monthly?.free?.price,
      },
      list: [
        t("pricing.carts.free._1"),
        t("pricing.carts.free._2"),
        t("pricing.carts.free._3"),
        t("pricing.carts.free._4"),
        t("pricing.carts.free._5", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
        t("pricing.carts.free._6", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
      ],
      link: t("pricing.free.link")
    },
    {
      has: !!plans?.monthly?.payAsGo,
      header: t("pricing.payAsGo.header"),
      pricing: {
        value: plans?.monthly?.payAsGo?.price,
      },
      list: [
        t("pricing.carts.payAsGo._1"),
        t("pricing.carts.payAsGo._2"),
        t("pricing.carts.payAsGo._3"),
        t("pricing.carts.payAsGo._4"),
        t("pricing.carts.payAsGo._5", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
        t("pricing.carts.payAsGo._6", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
      ],
      link: t("pricing.payAsGo.link")
    },
    {
      has: !!plans?.monthly?.starter,
      header: t("pricing.starter.header"),
      pricing: {
        value: plans?.monthly?.starter?.price,
      },
      list: [
        t("pricing.carts.starter._1"),
        t("pricing.carts.starter._2"),
        t("pricing.carts.starter._3"),
        t("pricing.carts.starter._4"),
        t("pricing.carts.starter._5", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
        t("pricing.carts.starter._6", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
      ],
      link: t("pricing.starter.link")
    },
    {
      has: !!plans?.monthly?.standard,
      header: t("pricing.standard.header"),
      pricing: {
        value: plans?.monthly?.standard?.price,
      },
      list: [
        t("pricing.carts.standard._1"),
        t("pricing.carts.standard._2"),
        t("pricing.carts.standard._3"),
        t("pricing.carts.standard._4"),
        t("pricing.carts.standard._5", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
        t("pricing.carts.standard._6", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
      ],
      link: t("pricing.standard.link")
    },
    {
      has: !!plans?.monthly?.advance,
      header: t("pricing.advance.header"),
      pricing: {
        value: plans?.monthly?.advance?.price,
      },
      list: [
        t("pricing.carts.advance._1"),
        t("pricing.carts.advance._2"),
        t("pricing.carts.advance._3"),
        t("pricing.carts.advance._4"),
        t("pricing.carts.advance._5", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
        t("pricing.carts.advance._6", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
      ],
      link: t("pricing.advance.link")
    },
    {
      has: !!plans?.monthly?.enterPrice,
      header: t("pricing.enterPrice.header"),
      pricing: {
        value: plans?.monthly?.enterPrice?.price,
      },
      list: [
        t("pricing.carts.enterPrice._1"),
        t("pricing.carts.enterPrice._2"),
        t("pricing.carts.enterPrice._3"),
        t("pricing.carts.enterPrice._4"),
        t("pricing.carts.enterPrice._5", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
        t("pricing.carts.enterPrice._6", {}, {fallback: `${COMMON_NAMESPACE}:fallback`}),
      ],
      link: t("pricing.enterPrice.link")
    }
  ]

  const cartsYearly = [
    {
      has: !!plans?.yearly?.standard,
      header: t("pricing.standard.header"),
      pricing: {
        value: plans?.yearly?.standard?.price,
      },
      list: [
        t("pricing.carts.standard._1"),
        t("pricing.carts.standard._2"),
        t("pricing.carts.standard._3"),
        t("pricing.carts.standard._4"),
        t("pricing.carts.standard._5"),
        t("pricing.carts.standard._6"),
      ],
      link: t("pricing.standard.link")
    },
    {
      has: !!plans?.yearly?.advance,
      header: t("pricing.advance.header"),
      pricing: {
        value: plans?.yearly?.advance?.price,
      },
      list: [
        t("pricing.carts.advance._1"),
        t("pricing.carts.advance._2"),
        t("pricing.carts.advance._3"),
        t("pricing.carts.advance._4"),
        t("pricing.carts.advance._5"),
        t("pricing.carts.advance._6"),
      ],
      link: t("pricing.advance.link")
    }
  ]

  const carts = payment === MONTHLY ? cartsMonthly : cartsYearly;

  return (
    <section className={styles["carts"]}>
      <div className={styles["carts__wrapper"]}>
        {
          carts.map((cart, i) => {
            if (!cart.has) {
              return ;
            }
            return (
              <div key={i} className={cn(styles["cart"], {[styles["cart-bg"]] : i % 2 === 0})}>
                <h3 className={styles["cart__header"]}>{cart.header}</h3>
                <div className={styles["cart__pricing-wrapper"]}>
                  <span className={styles["cart__value-type"]}>$</span>
                  <div className={styles["cart__pricing-wrap"]}>
                    <span className={styles["cart__price-value"]}>{cart.pricing.value}</span>
                    <span className={styles["cart__price-label"]}>/ {t("pricing.payment.monthly.label")}</span>
                  </div>
                </div>
                <ul className={styles["cart__list"]}>
                  {cart.list.map((feature, i) => {
                    if (feature === "") {
                      return null;
                    }
                    return (
                      <li key={i} className={styles["cart__item"]}>
                        {feature}
                      </li>
                    )
                  })}
                </ul>
                <Button primary fullWidth url={signUtmParams(link, router)} external>{cart.link}</Button>
              </div>
            )
          })
        }
      </div>
    </section>
  );
};

Cards.propTypes = {
  namespace: PropTypes.oneOf(["selectors", "reactFlow", "recharge"])
}

export default Cards;
